module.exports = __webpack_public_path__ + "media/images/gallery/constellations/orion/ori_lines-f8e6546cb6d6c6ccdad1a8be172484b2.gif";